module.exports = __webpack_public_path__ + "static/media/video_consent_audio_telugu.f87b8a15.mp3";